module.exports = __webpack_public_path__ + "static/media/CV.97e0a8d1.png";